export const OBSIDIAN = '#05050A';
export const GOLD = '#D4AF37';
export const GOLD_LIGHT = '#FFE9A0';
export const NUM_FONT = "font-['Outfit']";

export const PILLARS = [
  { id: 'pact', numeral: 'I', name: 'Sovereign Oath', tagline: 'A promise kept to yourself is the root of confidence', accent: '#D4AF37', light: '#FFE9A0', glow: 'rgba(212,175,55,0.55)' },
  { id: 'hits', numeral: 'II', name: 'Grateful Fix', tagline: 'Count what is going right — and crave it', accent: '#5BE08A', light: '#C9FFD9', glow: 'rgba(91,224,138,0.5)' },
  { id: 'lock', numeral: 'III', name: 'Laser Lock', tagline: 'Choose your good. Shatter the noise.', accent: '#5DD4FF', light: '#D4F3FF', glow: 'rgba(93,212,255,0.5)' },
];

export const REALMS = [
  { id: 'discipline', label: 'Discipline', emoji: '⚔️', color: '#D4AF37', vows: ['Today, I choose discipline over mood.', 'Today, I finish what I start.', 'Today, I do the hard thing first.'] },
  { id: 'wealth', label: 'Wealth', emoji: '👑', color: '#FFB265', vows: ['Today, I refuse to entertain scarcity.', 'Today, I make one move that grows my wealth.', 'Today, I spend only on what builds my empire.'] },
  { id: 'body', label: 'Body', emoji: '🔥', color: '#FF6478', vows: ['Today, I move my body like a warrior.', 'Today, I fuel my body with clean power.', 'Today, I sleep on time and wake as a king.'] },
  { id: 'peace', label: 'Peace', emoji: '🕊️', color: '#5DD4FF', vows: ['Today, I protect my peace at all costs.', 'Today, I respond, I never react.', 'Today, I let go of what I cannot control.'] },
  { id: 'courage', label: 'Courage', emoji: '🦁', color: '#B978FF', vows: ['Today, I speak only power over my life.', 'Today, I do the one thing I fear.', 'Today, I walk in like I own the room.'] },
];

export const HIT_KIND_META = {
  win: { label: 'A Win', emoji: '🏆', color: '#FFD45C', hint: 'Something went right today', placeholder: 'Finished my workout before 7am…' },
  person: { label: 'A Person', emoji: '🤗', color: '#5DD4FF', hint: 'Someone who helped or lifted me', placeholder: 'Mom called just to check on me…' },
  blessing: { label: 'A Blessing', emoji: '🎁', color: '#5BE08A', hint: 'Something good I already have', placeholder: 'A roof, health and a fresh day…' },
  power: { label: 'A Win', emoji: '⚡', color: '#B978FF' },
  asset: { label: 'A Blessing', emoji: '💎', color: '#5BE08A' },
};
export const HIT_KINDS = ['win', 'person', 'blessing'];
export const DAILY_HIT_GOAL = 3;

export const DISTRACTIONS = ['doubt', 'scroll', 'fear', 'gossip', 'what if', 'excuses', 'comparison', 'scarcity', 'regret', 'drama', 'later', 'noise', 'envy', 'worry'];

export const localDateKey = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const lastNDays = (n, today = new Date()) =>
  Array.from({ length: n }, (_, i) => {
    const d = new Date(today);
    d.setDate(d.getDate() - (n - 1 - i));
    return localDateKey(d);
  });
